"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// browser
__export(require("./browser/BrowserAztecCodeReader"));
__export(require("./browser/BrowserBarcodeReader"));
__export(require("./browser/BrowserCodeReader"));
__export(require("./browser/BrowserDatamatrixCodeReader"));
__export(require("./browser/BrowserMultiFormatReader"));
__export(require("./browser/BrowserPDF417Reader"));
__export(require("./browser/BrowserQRCodeReader"));
__export(require("./browser/BrowserQRCodeSvgWriter"));
__export(require("./browser/HTMLCanvasElementLuminanceSource"));
__export(require("./browser/VideoInputDevice"));
//# sourceMappingURL=browser.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zxing/library/esm5/browser.js
// module id = 160
// module chunks = 0